import { Box, Typography } from '@mui/material';
import React from 'react';

import { ResetButton } from './ResetButton';

interface IProps {
  message: string;
  onClick: () => void;
  dataAction?: string;
}

export const ResetPlaceholder: React.FC<IProps> = ({ message, onClick, dataAction }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Typography sx={{ fontSize: 12 }} color="text.secondary">
        {message}
      </Typography>
      <ResetButton onClick={onClick} dataAction={dataAction} sx={{ fontSize: 13 }} />
    </Box>
  );
};
